export default "varying vec2 vUV;\n\nvoid main() {\n\tvUV = uv;\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}\n"